import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { actions as casinoActions } from 'features/casino';
import { slotProvidersConfiguration } from '../configuration';

const withFetchCasinoLayoutContentDesktop = (WrappedComponent: React.FC) => (props: any) => {
  const dispatch = useDispatch();
  const isAuth = useSelector((state: any) => state.auth.isAuth, shallowEqual);

  useEffect(() => {
    if (!isAuth) dispatch(casinoActions.clearExtraData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);
  useEffect(() => {
    Object.entries(slotProvidersConfiguration).forEach(configuration => {
      if (configuration[1].platform?.indexOf('desktop') !== -1 || !configuration[1].platform)
        dispatch(casinoActions.getGameList({ provider: configuration[0], platform: 'desktop' }));
    });
  }, [isAuth, dispatch]);

  return <WrappedComponent {...props} />;
};

// eslint-disable-next-line no-unused-vars
const withFetchCasinoLayoutContentMobile = (WrappedComponent: React.FC, tag: string) => (props: any) => {
  const dispatch = useDispatch();
  const isAuth = useSelector((state: any) => state.auth.isAuth, shallowEqual);

  useEffect(() => {
    if (!isAuth) dispatch(casinoActions.clearExtraData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  useEffect(() => {
    Object.entries(slotProvidersConfiguration).forEach(configuration => {
      if (configuration[1].platform?.indexOf('mobile') !== -1 || !configuration[1].platform)
        dispatch(casinoActions.getGameList({ provider: configuration[0], platform: 'mobile' }));
    });
  }, [isAuth, dispatch]);

  return <WrappedComponent {...props} />;
};

export { withFetchCasinoLayoutContentDesktop, withFetchCasinoLayoutContentMobile };
